import * as z from "zod";

export const getStayAiIntegration = {
  name: "getStayAiIntegration" as const,
  input: z.null(),
  output: z.object({ exists: z.boolean() }),
};
